import(/* webpackMode: "eager" */ "/vercel/path0/Website/components/blogs/BlogPostComponent.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/Website/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")